import type { AxiosError } from "axios"
import { ref } from "vue"

import type { ApiErrorResponse } from "@/types/api/contracts"

export const useServerFormErrors = () => {
  const serverErrors = ref<Record<string, string[]>>({})

  const clearServerErrors = () => {
    serverErrors.value = {}
  }
  const clearServerError = (field: string) => {
    const errors = { ...serverErrors.value }
    delete errors[field]
    serverErrors.value = errors
  }
  const getFieldErrorProps = (field: string) =>
    serverErrors.value[field]?.length
      ? { validateStatus: "error", help: serverErrors.value[field].join(" ") }
      : {}

  const setServerErrors = (
    error: AxiosError<ApiErrorResponse>,
    fieldAliases: Record<string, string[]> = {}
  ) => {
    clearServerErrors()
    const details = error.response?.data?.details

    if (!details || Array.isArray(details)) return

    const errors: Record<string, string[]> = {}
    Object.entries(details).forEach(([field, messages]) => {
      if (field === "_general") return

      const formFields = fieldAliases[field] || [field]
      formFields.forEach((formField) => {
        errors[formField] = [...(errors[formField] || []), ...messages]
      })
    })
    serverErrors.value = errors
  }

  return { getFieldErrorProps, setServerErrors, clearServerError, clearServerErrors }
}
